import { SessionState, SessionAction, SessionActionTypes } from './sessionTypes';

const initialState: SessionState = {
  loadingSession: false,
  loadingLogin: false,
  logged: false,
  failed: null,
  error: false,
  user: null,
  selectedChurchIndex: null,
};

export default function sessionReducer(
  state = initialState,
  action: SessionAction,
): SessionState {
  switch (action.type) {
    case SessionActionTypes.LOGIN_START:
      return {
        ...state,
        loadingLogin: true,
        failed: null,
        error: false,
      };

    case SessionActionTypes.LOGIN_FAIL:
      if (!action.failed) {
        throw new Error();
      }
      return {
        ...state,
        failed: action.failed,
        loadingLogin: false,
      };

    case SessionActionTypes.LOGIN_ERROR:
      return {
        ...state,
        error: true,
        loadingLogin: false,
      };

    case SessionActionTypes.LOGIN_SUCCESS:
      if (!action.user) {
        throw new Error();
      }
      return {
        ...state,
        loadingLogin: false,
        logged: true,
        failed: null,
        error: false,
        user: {
          ...action.user,
          churches: action.user.churches.sort((a: any, b: any) => {
            if (a.name < b.name) { return -1; }
            if (a.name > b.name) { return 1; }
            return 0;
          }),
        },
        selectedChurchIndex: 0,
      };

    case SessionActionTypes.SESSION_START:
      return {
        ...state,
        loadingSession: true,
      };

    case SessionActionTypes.SESSION_SUCCESS:
      if (!action.user) {
        throw new Error();
      }
      return {
        ...state,
        loadingSession: false,
        logged: true,
        failed: null,
        error: false,
        user: {
          ...action.user,
          churches: action.user.churches.sort((a: any, b: any) => {
            if (a.name < b.name) { return -1; }
            if (a.name > b.name) { return 1; }
            return 0;
          }),
        },
        selectedChurchIndex: 0,
      };

    case SessionActionTypes.SESSION_FAIL:
      return initialState;

    case SessionActionTypes.CHANGE_CHURCH:
      if (action.selectedChurchIndex === null) {
        throw new Error();
      }
      return {
        ...state,
        selectedChurchIndex: action.selectedChurchIndex,
      };

    case SessionActionTypes.LOGOUT:
      return initialState;

    default:
      return state;
  }
}
